
import { Link } from 'react-router-dom';

export function MetodoTeaser() {
  const puntiChiave = [
    'Raccolta dati multi-fonte',
    'Analisi integrata e ponderata', 
    'Validazione e certificazione'
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Immagine Sinistra */}
          <div className="relative order-2 lg:order-1">
            <img
              src="https://public.readdy.ai/ai/img_res/7acb9b173e7de47a1a0cac5dc8306706.jpg"
              alt="Visualizzazione metodologia scientifica Brand Capital"
              className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-r-3xl shadow-2xl"
            />
          </div>

          {/* Contenuto Destro */}
          <div className="order-1 lg:order-2 lg:pl-8">
            <div className="inline-block bg-green-100 text-green-700 text-sm font-bold px-5 py-2 rounded-full mb-6">
              IL METODO
            </div>
            
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-6 leading-tight">
              Un Approccio Scientifico alla Valutazione
            </h2>
            
            <p className="text-base lg:text-lg text-gray-600 leading-relaxed mb-8">
              Il nostro metodo proprietario trasforma la valutazione del brand da processo soggettivo a dato oggettivo. Scegliere Brand Capital significa adottare un metodo che consente di far diventare il marchio un asset immateriale aumentando il patrimonio netto in bilancio e conseguentemente migliorare l'affidabilità del rating bancario, oltre a misurare e dare valore all'azienda e al lavoro svolto negli anni per l'immagine aziendale, con dati tracciabili, affidabili, replicabili e difendibili.
            </p>

            <div className="space-y-4 mb-10">
              {puntiChiave.map((punto, index) => (
                <div key={index} className="flex items-center">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-sm lg:text-base text-gray-700 font-medium">{punto}</span>
                </div>
              ))}
            </div>

            <div className="space-y-3">
              <Link
                to="/servizi"
                className="inline-flex items-center bg-slate-900 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold hover:bg-slate-800 transition-colors duration-300 whitespace-nowrap text-sm sm:text-base"
              >
                Scopri il Metodo Completo
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <p className="text-sm text-gray-500 ml-2">
                Approfondimento tecnico nella sezione dedicata
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
